export default __webpack_public_path__ + "static/media/0060.e4905171.png";